import { extendTheme } from "@chakra-ui/react";

import * as themeConfig from "./themeConfig";

import { components } from "./components";
import { breakpoints } from "./breakpoints";
import { fontVariants } from "./fontVariants";

const styles = {
  global: {
    ...fontVariants,
    body: {
      ...fontVariants
    }
  }
};

const appTheme = {
  styles,
  breakpoints,
  components,
  ...themeConfig
};

export const theme = extendTheme(appTheme);
